
import Vue, { PropType } from 'vue'
import CustomTextModal from './CustomTextModal.vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'ConfirmJobDeleteModal',
  components: {
    CustomTextModal,
    RButton,
  },
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
    browseUrls: {
      type: Array as PropType<{ driveLocationUrl: string; text: string }[]>,
    },
  },
  computed: {
    targetStr(): string {
      return `record${this.browseUrls.length > 1 ? 's' : ''}`
    },
  },
})
